import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';

// Node modules
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { BsDropdownModule } from 'ngx-bootstrap';
import { AlertModule } from 'ngx-bootstrap/alert';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxCurrencyModule } from 'ngx-currency';
import { NgxMaskModule } from 'ngx-mask';

// Components
import { CancelSuccessComponent } from '../components/cancel-success/cancel-success.component';
import { ContractTermsFreeTrialModalComponent } from '../components/contract-terms-free-trial-modal/contract-terms-free-trial-modal.component';
import { ContractTermsFreeTrialUpgradeModalComponent } from '../components/contract-terms-free-trial-upgrade-modal/contract-terms-free-trial-upgrade-modal.component';
import { ContractTermsModalComponent } from '../components/contract-terms-modal/contract-terms-modal.component';
import { Error404Component } from '../components/error404/error404';
import { FreeTrialCancelComponent } from '../components/free-trial-cancel/free-trial-cancel.component';
import { FreeTrialUpgradeComponent } from '../components/free-trial-upgrade/free-trial-upgrade.component';
import { FreeTrialVerifyComponent } from '../components/free-trial-verify/free-trial-verify.component';
import { FreeTrialComponent } from '../components/free-trial/free-trial.component';
import { PrivacyPolicyModalComponent } from '../components/privacy-policy-modal/privacy-policy-modal.component';
import { ProgressBarComponent } from '../components/progress-bar/progress-bar.component';
import { RegisterPaymentComponent } from '../components/register-payment/register-payment.component';
import { RegisterSchoolComponent } from '../components/register-school/register-school.component';
import { RegisterUserComponent } from '../components/register-user/register-user.component';
import { SignUpAuthComponent } from '../components/sign-up-auth/sign-up-auth.component';
import { SignUpComponent } from '../components/sign-up/sign-up.component';
import { Success200Component } from '../components/success200/success200.component';
import { TermsOfServiceModalComponent } from '../components/terms-of-service-modal/terms-of-service-modal.component';
import { AppComponent } from './app.component';

// Services
import { AnalyticsService } from '../services/analytics.service';
import { AppService } from '../services/app.service';
import { AuthGuard } from '../services/auth-guard.service';
import { AuthService } from '../services/auth.service';
import { DataService } from '../services/data.service';
import { FreeTrialService } from '../services/free-trial.service';
import { SortingService } from '../services/sort.service';
import { UploadService } from '../services/upload.service';
import { MomentService } from '../services/moment.service';

// Directives
import { FreeTrialUpgradeV2Component } from '../components/free-trial-upgrade-v2/free-trial-upgrade-v2.component';
import { PricingPlanComponent } from '../components/pricing-plan/pricing-plan.component';
import { InputRestrictionDirective } from '../directives/input-restriction.directive';

export var firebaseConfig = {
	apiKey: 'AIzaSyCmQLcEaZUYUr4upoY4oBsoMTfBxtqnBPc',
	authDomain: 'quickkidz-c0638.firebaseapp.com',
	databaseURL: 'https://quickkidz-c0638.firebaseio.com',
	projectId: 'quickkidz-c0638',
	storageBucket: 'quickkidz-c0638.appspot.com',
	messagingSenderId: '98163640962',
};

// export var betaFirebaseConfig = {
//   apiKey: "AIzaSyDngxS_nBI2s8-KdI7UQvDqwkjlu1BS4Pk",
//   databaseURL:"https://betachildpilot.firebaseio.com",
//   projectId: "betachildpilot",
//   storageBucket: "gs://betachildpilot.appspot.com"
// };

// Routes
const appRoutes: Routes = [
	{
		path: '',
		redirectTo: '/sign-up',
		pathMatch: 'full',
	},
	{
		path: '',
		children: [
			{ path: 'sign-up', component: SignUpComponent },
			{
				path: 'sign-up-auth',
				canActivate: [],
				component: SignUpAuthComponent,
			},
			{ path: 'free-trial', component: Error404Component },
			{
				path: 'free-trial-upgrade',
				component: FreeTrialUpgradeComponent,
			},
			{ path: 'free-trial-verify', component: FreeTrialVerifyComponent },
			{
				path: 'v2/free-trial-upgrade',
				component: FreeTrialUpgradeV2Component,
			},
			{ path: 'free-trial-cancel', component: FreeTrialCancelComponent },
			{ path: 'success200', component: Success200Component },
			{ path: 'success201', component: CancelSuccessComponent },
			{ path: 'error404', component: Error404Component },
		],
	},
	//{ path: '**', component:  }
];

@NgModule({
	declarations: [
		AppComponent,
		SignUpComponent,
		SignUpAuthComponent,
		TermsOfServiceModalComponent,
		PrivacyPolicyModalComponent,
		ContractTermsModalComponent,
		Error404Component,
		Success200Component,
		FreeTrialComponent,
		InputRestrictionDirective,
		ContractTermsFreeTrialModalComponent,
		FreeTrialUpgradeComponent,
		FreeTrialCancelComponent,
		CancelSuccessComponent,
		RegisterUserComponent,
		RegisterSchoolComponent,
		RegisterPaymentComponent,
		ProgressBarComponent,
		ContractTermsFreeTrialUpgradeModalComponent,
		PricingPlanComponent,
		FreeTrialUpgradeV2Component,
		FreeTrialVerifyComponent,
	],
	entryComponents: [
		TermsOfServiceModalComponent,
		PrivacyPolicyModalComponent,
		ContractTermsModalComponent,
		ContractTermsFreeTrialModalComponent,
		ContractTermsFreeTrialUpgradeModalComponent,
	],
	imports: [
		BrowserModule,
		HttpModule,
		RouterModule.forRoot(appRoutes),
		FormsModule,
		CreditCardDirectivesModule,
		ReactiveFormsModule,
		AngularFireModule.initializeApp(firebaseConfig),
		AngularFireAuthModule,
		AngularFirestoreModule,
		AngularFireStorageModule,
		CollapseModule.forRoot(),
		ModalModule.forRoot(),
		AlertModule.forRoot(),
		BsDropdownModule.forRoot(),
		NgxCurrencyModule,
		NgxMaskModule.forRoot(),
		BsDatepickerModule.forRoot(),
		RecaptchaModule,
		RecaptchaFormsModule,
	],
	providers: [
		AppService,
		DataService,
		AuthService,
		AuthGuard,
		SortingService,
		UploadService,
		AnalyticsService,
		FreeTrialService,
		MomentService
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
